const findDupeIndex = (list) => list.findIndex((item, index) => list.lastIndexOf(item) !== index);

export default findDupeIndex;
